import { DBDoc } from '@fry/lib/store/store.interface';
import { BaseModel } from '@fry/lib/store';

import { WalkthroughStepState, WalkthroughStepStateJSON } from './walkthrough-step-state';

export interface WalkthroughStateJSON extends DBDoc {
    hidden: boolean;
    generatedAt: string;
    state: WalkthroughStepStateJSON;
}

export class WalkthroughState extends BaseModel {
    hidden: boolean;
    generatedAt: string;
    state: WalkthroughStepStateJSON;

    constructor(doc: WalkthroughStateJSON) {
        super(doc);

        this.id = doc.state.id;
        this.hidden = doc.hidden;
        this.generatedAt = doc.generatedAt;
    }

    public static stateFromJSON(json: WalkthroughStateJSON): WalkthroughState {
        const state = new WalkthroughState(json);
        state.state = WalkthroughStepState.stateFromJSON(json.state);
        return state;
    }
}
